import { ChakraV3, RangeDatepicker } from '@piccolohealth/ui';
import type { DateTime } from '@piccolohealth/util';
import React from 'react';

interface Props {
  startDate: DateTime;
  endDate: DateTime;
  onStartDateChange: (date: DateTime) => void;
  onEndDateChange: (date: DateTime) => void;
}

export const ParticipantWidgetTimeRangeControl = (props: Props) => {
  return (
    <ChakraV3.Stack w='220px'>
      <RangeDatepicker
        startDate={props.startDate}
        endDate={props.endDate}
        onStartDateChange={(v) => v && props.onStartDateChange(v)}
        onEndDateChange={(v) => v && props.onEndDateChange(v)}
        size='md'
        isClearable={false}
      />
    </ChakraV3.Stack>
  );
};
